import axios from "axios";
import generateCorrelationId from "./generateCorrelationId";
import getCurrentDatetime from "./getCurrentDatetime";
import showDownloadErrorToast from "./showDownloadError";

const getDownloadErrorPayload = async (data) => {
  if (!(data instanceof Blob)) return null;

  const contentType = data.type || "";
  const shouldTryJson =
    contentType.includes("json") || data.size < 1024 * 1024;

  if (!shouldTryJson) return null;

  try {
    const payload = JSON.parse(await data.text());
    return payload?.statusCode !== undefined && payload.statusCode !== 200
      ? payload
      : null;
  } catch {
    return null;
  }
};

// Dedicated GET helper for file downloads. A successful HTTP response always
// returns the downloaded blob through callback. API error payloads returned
// as a Blob are decoded and sent to errorCallback.
export default function axiosGetDownload({
  url,
  params,
  headers,
  callback,
  errorCallback,
  responseType = "blob",
  downloadProgress,
}) {
  axios
    .get(url, {
      headers: {
        ...headers,
        "X-Transmission-Date-Time": getCurrentDatetime(),
        "X-Correlation-Id": generateCorrelationId(),
      },
      params,
      responseType,
      onDownloadProgress: (progressEvent) => {
        if (!downloadProgress) return;

        const { loaded, total } = progressEvent;
        const percent = total ? Math.floor((loaded * 100) / total) : 0;
        downloadProgress(percent);
      },
    })
    .then(async (res) => {
      const errorPayload = await getDownloadErrorPayload(res.data);

      if (errorPayload) {
        showDownloadErrorToast(errorPayload);
        if (errorCallback) errorCallback(errorPayload);
        return;
      }

      if (callback) callback(res.data, res);
    })
    .catch((err) => {
      showDownloadErrorToast(err);
      if (errorCallback) errorCallback(err);
    });
}
